import { FAILURE, IDLE, REQUEST, SUCCESS } from 'src/redux/constants';
import { EDIT_CREATE_SURVEYS } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { EditCreateSurveys, EditCreateSurveysDataActionTypes } from './types';
import api from 'src/utils/api';

export const loadEditSurveys =
  (
    editServiys: EditCreateSurveys,
    id: number,
  ): ThunkAction<
    Promise<void>,
    State,
    null,
    EditCreateSurveysDataActionTypes
  > =>
  async (dispatch: any) => {
    dispatch({ type: EDIT_CREATE_SURVEYS + REQUEST });
    try {
      const payload = await api.loadEditSurvey(editServiys, id);
      dispatch({ type: EDIT_CREATE_SURVEYS + SUCCESS, payload });
    } catch (error) {
      dispatch({ type: EDIT_CREATE_SURVEYS + FAILURE, error });
    }
  };

export const createSurveysIdle = () => ({ type: EDIT_CREATE_SURVEYS + IDLE });
